type Primitivos = string | number;

export const contieneTodos = <T>(arr1: Array<T>, arr2: Array<T>): boolean =>
  arr2.every((arr2Item) => arr1.includes(arr2Item));

// Solo funciona para primitivos, orden no importa
export const contienenLoMismo = <T extends Primitivos>(
  arrA: Array<T>,
  arrB: Array<T>
): boolean => {
  if (arrA.length !== arrB.length) {
    return false;
  }
  return contieneTodos(arrA, arrB) && contieneTodos(arrA, arrB);
};
